import createIcon from '../../createIcon';

/**
 * @component @name DirectionsRun
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNTUwMiA1LjI1QzE1LjY1MDIgNS4yNSAxNi41NTAyIDQuMzUgMTYuNTUwMiAzLjI1QzE2LjU1MDIgMi4xNSAxNS42NTAyIDEuMjUgMTQuNTUwMiAxLjI1QzEzLjQ1MDIgMS4yNSAxMi41NTAyIDIuMTUgMTIuNTUwMiAzLjI1QzEyLjU1MDIgNC4zNSAxMy40NTAyIDUuMjUgMTQuNTUwMiA1LjI1Wk0xMC45NTAyIDE5LjE1TDExLjk1MDIgMTQuNzVMMTQuMDUwMiAxNi43NVYyMi43NUgxNi4wNTAyVjE1LjI1TDEzLjk1MDIgMTMuMjVMMTQuNTUwMiAxMC4yNUMxNS44NTAyIDExLjc1IDE3Ljg1MDIgMTIuNzUgMjAuMDUwMiAxMi43NVYxMC43NUMxOC4xNTAyIDEwLjc1IDE2LjU1MDIgOS43NSAxNS43NTAyIDguMzVMMTQuNzUwMiA2Ljc1QzE0LjM1MDIgNi4xNSAxMy43NTAyIDUuNzUgMTMuMDUwMiA1Ljc1QzEyLjc1MDIgNS43NSAxMi41NTAyIDUuODUgMTIuMjUwMiA1Ljg1TDcuMDUwMTkgOC4wNVYxMi43NUg5LjA1MDE5VjkuMzVMMTAuODUwMiA4LjY1TDkuMjUwMTkgMTYuNzVMNC4zNTAyIDE1Ljc1TDMuOTUwMiAxNy43NUwxMC45NTAyIDE5LjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsRun = createIcon('DirectionsRun', [
  [
    'path',
    {
      d: 'M14.5502 5.25C15.6502 5.25 16.5502 4.35 16.5502 3.25C16.5502 2.15 15.6502 1.25 14.5502 1.25C13.4502 1.25 12.5502 2.15 12.5502 3.25C12.5502 4.35 13.4502 5.25 14.5502 5.25ZM10.9502 19.15L11.9502 14.75L14.0502 16.75V22.75H16.0502V15.25L13.9502 13.25L14.5502 10.25C15.8502 11.75 17.8502 12.75 20.0502 12.75V10.75C18.1502 10.75 16.5502 9.75 15.7502 8.35L14.7502 6.75C14.3502 6.15 13.7502 5.75 13.0502 5.75C12.7502 5.75 12.5502 5.85 12.2502 5.85L7.05019 8.05V12.75H9.05019V9.35L10.8502 8.65L9.25019 16.75L4.3502 15.75L3.9502 17.75L10.9502 19.15Z',
      key: '1ik66q',
    },
  ],
]);

export default DirectionsRun;
